import React, { useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { Link } from 'gatsby';

import { useSiteMetadata } from '../../hooks/use-site-metadata';

/**
 * Transform a link in markdown to an internal or external link.
 */
export const MarkdownLink = ({ children, href }) => {
	const { siteUrl } = useSiteMetadata();

	const isInternalLink = useMemo(
		() => href.startsWith('/') || href === '' || href.includes(siteUrl),
		[href, siteUrl],
	);
	// If the link is local it will start with a "/"
	// Otherwise it'll be something like "https://"
	return isInternalLink ? (
		<Box as={Link} to={href}>
			{children}
		</Box>
	) : (
		<a href={href} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	);
};
